<template>
  <div>

    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="tmnts !== null && tmnts.length > 0" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Type</th>
          <th scope="col">Status</th>
          <th scope="col">Started At</th>
          <th scope="col">Remaining Time</th>
          <th scope="col">Expected Finish</th>
          <th scope="col">Finished At</th>
        </tr>
      </thead>
      <tr
        v-for="tmnt in tmnts"
        :key="tmnt.id"
      >
        <td>
          Contest {{tmnt.id}}
        </td>
        <td>{{tmnt.type | getContestTypeName}}</td>
        <td
          :class="getContestStatusClass(tmnt.status)"
        >
          {{tmnt.status | getEnumTmntStatusNameFormatted}}
        </td>
        <td>{{tmnt.ctime | getMomentStr}}</td>
        <td>{{getRemainingTimeStr(tmnt)}}</td>
        <td>{{tmnt.ftime | getMomentStr}}</td>
        <td>{{tmnt.frtime | getContestRealFinishTimeStr}}</td>
      </tr>
    </table>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';

import { getContestTypeName             } from '../model/contest.js';
import { getEnumTmntStatusNameFormatted } from '../model/contest.js';
import { getContestStatusClass          } from '../model/contest.js';
import { getContestRemainingTimeStr     } from '../model/contest.js';
import { getContestRealFinishTimeStr    } from '../model/contest.js';

export default {
  name: 'PlayerTmnts',

  components: {
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      isLoading: false,
      tmnts: null,

      timerId: null,
      nowSec: Date.now() / 1000,
    };
  },

  computed: {
    message() {
      if(this.tmnts !== null && this.tmnts.length === 0) {
        return 'No contests.';
      }
      return null;
    },
  },

  created() {
    this.timerId = setInterval(this.updateTime, 1000);

    notifier.deleteSenderNotifications(this);
    this.isLoading = true;

    const url = `/player/${this.playerId}/tmnts`;
    HTTP.get(url)
    .then(response => {
      this.isLoading = false;

      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      this.tmnts = data;
    })
    .catch(e => {
      this.isLoading = false;
      notifier.showError(e.response.data, {sender: this});
    });
  },

  beforeDestroy() {
    if(this.timerId !== null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  },

  methods: {
    updateTime() {
      this.nowSec = Date.now() / 1000;
    },

    getRemainingTimeStr(tmnt) {
      return getContestRemainingTimeStr(tmnt, this.nowSec);
    },

    getContestStatusClass,
  },

  filters: {
    getContestTypeName,
    getEnumTmntStatusNameFormatted,
    getContestRealFinishTimeStr,
  },
};
</script>
